module.exports = __webpack_public_path__ + "static/media/Lyft.ecdca1a3.svg";